// - fx/FXEngine.js
/**
 * FXEngine — Scroll-based progress interpolator (t ∈ [0, 1])
 * ----------------------------------------------------------
 * Computes a normalized progress value for each element based
 * on viewport-defined limits, then executes the user callback:
 *
 *   callback(el, t, rect)
 *
 * Ideal for:
 *   - opacity and transform animations
 *   - clip-path / mask interpolations
 *   - CSS variable morphing
 *   - any continuous scroll-driven animation
 */

import { clamp } from "../utils/math";
import { debounceRAF } from "../utils/timing";
import { resolveLimit } from "./utils/resolveLimit";

export class FXEngine {

    constructor(options) {

        this.selector = options.selector;
        this.limits   = options.limits;
        this.callback = options.callback;

        this.items = [...document.querySelectorAll(this.selector)];

        this.animate = this.animate.bind(this);

        this.init();

    }

    init() {

        this.animate();  

        window.addEventListener("scroll", debounceRAF(this.animate));

    }

    animate() {

        const startPx = resolveLimit(this.limits.start);
        const endPx   = resolveLimit(this.limits.end);

        const a = Math.min(startPx, endPx);
        const b = Math.max(startPx, endPx);
        const delta = b - a || 1;

        this.items.forEach(el => {

            const rect = el.getBoundingClientRect();
            const pos  = rect.top;

            let t = (pos - a) / delta;
            t = clamp(t);

            this.callback(el, t, rect);

        });

    }

}